module.exports = __webpack_public_path__ + "img/steel-img-2.3d8dffb2.png";